import {
  AuditOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CarOutlined,
  CloudServerOutlined,
  DesktopOutlined,
  DollarOutlined,
  GiftOutlined,
  GoldOutlined,
  HomeOutlined,
  LogoutOutlined,
  PictureOutlined,
  SelectOutlined,
  SettingOutlined,
  SearchOutlined,
  ShopOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  BarcodeOutlined,
  BuildOutlined,
  SlidersOutlined,
  OneToOneOutlined,
  EuroCircleOutlined,
  AppstoreOutlined,
  NotificationOutlined,
  PhoneOutlined,
  MessageOutlined,
  ScheduleOutlined,
  NodeIndexOutlined,
  LineChartOutlined,
  KeyOutlined,
  MedicineBoxOutlined,
  IssuesCloseOutlined,
  CheckCircleOutlined,
  AccountBookOutlined,
  FlagOutlined,
  LaptopOutlined,
  Loading3QuartersOutlined,
  BankOutlined,
  PercentageOutlined,
  ExperimentOutlined,
  BulbOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Layout, Menu, notification, Input } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  IoAirplane,
  IoAlertOutline,
  IoApertureOutline,
  IoBagAddOutline,
  IoBoatOutline,
  IoCashOutline,
  IoCheckboxOutline,
  IoCheckmarkCircle,
  IoCheckmarkCircleOutline,
  IoCog,
  IoDocument,
  IoDocumentOutline,
  IoExpandOutline,
  IoImage,
  IoImageOutline,
  IoPaperPlane,
  IoSparkles,
  IoSparklesOutline,
  IoStar,
  IoStarOutline,
  IoStorefront,
  IoStorefrontOutline,
} from "react-icons/io5";
import SubMenu from "antd/es/menu/SubMenu";
import { logoutAdmin } from "../actions/AuthAction";
import { isPermitted } from "../utils/PermissionManager";
import { FiLoader } from "react-icons/fi";
import { BsCheck2Square, BsCurrencyDollar, BsListCheck } from "react-icons/bs";
import { BiDollarCircle, BiEuro, BiGridHorizontal } from "react-icons/bi";
import { MdCurrencyYuan, MdDisabledVisible } from "react-icons/md";
//   import { sidebarItems } from "../utils/Sidebars";
const { Sider } = Layout;

export default function SideMenu(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const roles = useSelector((state) => state.auth.profile?.roles);

  const [searchQuery, setSearchQuery] = useState("");
  const [userOpenKeys, setUserOpenKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  const searchInputRef = React.useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        e.key === "/" &&
        document.activeElement !== searchInputRef.current?.input &&
        document.activeElement.tagName !== "INPUT" &&
        document.activeElement.tagName !== "TEXTAREA"
      ) {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
      message: message,
      description: description,
    });
  };

  const menuStyle = {
    fontSize: "14px",
    width: "18px",
  };

  const rawMenuItems = [
    {
      key: "/",
      label: "Dashboard",
      icon: <HomeOutlined style={menuStyle} />,
      to: "/",
    },
    {
      key: "/customers",
      label: "Customers",
      icon: <TeamOutlined style={menuStyle} />,
      to: "/customers",
      roles: ["super_admin"],
    },
    {
      key: "/chat",
      label: "CRM Chat",
      icon: <MessageOutlined style={menuStyle} />,
      to: "/chat",
      roles: ["admin", "cn_purchase"],
    },
    {
      key: "/orders",
      label: "Orders",
      icon: <GoldOutlined style={menuStyle} />,
      to: "/orders",
      roles: [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_basic",
        "china_crm",
        "china_purchase",
        "china_admin",
        "order",
      ],
    },
    {
      key: "/sea-orders",
      label: "Sea",
      icon: <IoBoatOutline style={menuStyle} />,
      to: "/sea-orders",
      roles: ["admin"],
    },
    {
      key: "marketplace",
      label: "Marketplace",
      icon: <ShopOutlined style={menuStyle} />,
      roles: ["super_admin", "marketplace"],
      children: [
        {
          key: "/marketplace/stores",
          label: "Stores",
          icon: <BankOutlined style={menuStyle} />,
          to: "/marketplace/stores",
        },
        {
          key: "/marketplace/suppliers",
          label: "Suppliers",
          icon: <MessageOutlined style={menuStyle} />,
          to: "/marketplace/suppliers",
        },
        {
          key: "/marketplace/categories",
          label: "Categories",
          icon: <AppstoreOutlined style={menuStyle} />,
          to: "/marketplace/categories",
        },
        {
          key: "/marketplace/products",
          label: "Products",
          icon: <GoldOutlined style={menuStyle} />,
          to: "/marketplace/products",
        },
      ],
    },
    {
      key: "china-crm",
      label: "China CRM",
      icon: <IoBagAddOutline style={menuStyle} />,
      roles: ["admin", "china_crm"],
      children: [
        {
          key: "/china-crm/chat",
          label: "Chat",
          icon: <MessageOutlined style={menuStyle} />,
          to: "/china-crm/chat",
        },
        {
          key: "/china-crm/slow-orders",
          label: "Slow Orders",
          icon: <MdDisabledVisible style={menuStyle} />,
          to: "/china-crm/slow-orders",
        },
        {
          key: "/china-crm/supplier-response",
          label: "Supplier Response",
          icon: <IoStorefrontOutline style={menuStyle} />,
          to: "/china-crm/supplier-response",
        },
        {
          key: "/china-crm/purchase-center",
          label: "Purchase Center",
          icon: <AppstoreOutlined style={menuStyle} />,
          to: "/china-crm/purchase-center",
        },
        {
          key: "/china-crm/skyone-purchase",
          label: "SkyOne Purchase",
          icon: <MedicineBoxOutlined style={menuStyle} />,
          to: "/china-crm/skyone-purchase",
        },
        {
          key: "/china-crm/qc-customer",
          label: "Customer Qc",
          icon: <ScheduleOutlined style={menuStyle} />,
          to: "/china-crm/qc-customer",
        },
        {
          key: "/china-crm/support",
          label: "Support",
          icon: <PhoneOutlined style={menuStyle} />,
          to: "/china-crm/support",
        },
      ],
    },
    {
      key: "/skyone-purchase",
      label: "SkyOne Purchase",
      icon: <MedicineBoxOutlined style={menuStyle} />,
      to: "/skyone-purchase",
      roles: [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_purchase",
        "china_admin",
      ],
    },
    {
      key: "purchase-v4",
      label: "Purchase",
      icon: <IoBagAddOutline style={menuStyle} />,
      roles: [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_purchase",
        "china_admin",
      ],
      children: [
        {
          key: "/v4/supplier-response",
          label: "Supplier Response",
          icon: <IoStorefrontOutline style={menuStyle} />,
          to: "/v4/supplier-response",
          roles: [
            "admin",
            "bd_purchase",
            "cn_purchase",
            "china_purchase",
            "china_admin",
          ],
        },
        {
          key: "/v4/purchase-approval-center",
          label: "Approval Center",
          icon: <IoCheckmarkCircleOutline style={menuStyle} />,
          to: "/v4/purchase-approval-center",
          roles: ["super_admin", "bd_purchase"],
        },
        {
          key: "/v4/confirmation-center",
          label: "Confirmation Center",
          icon: <IoCheckboxOutline style={menuStyle} />,
          to: "/v4/confirmation-center",
          roles: ["super_admin"],
        },
        {
          key: "/v4/purchase-center",
          label: "Purchase Center",
          icon: <AppstoreOutlined style={menuStyle} />,
          to: "/v4/purchase-center",
          roles: [
            "admin",
            "bd_purchase",
            "cn_purchase",
            "china_purchase",
            "china_admin",
          ],
        },
        {
          key: "/supplier-confirmation",
          label: "Supplier Confirmation",
          icon: <IoCheckmarkCircleOutline style={menuStyle} />,
          to: "/supplier-confirmation",
          roles: [
            "admin",
            "cn_purchase",
            "china_purchase",
            "china_admin",
          ],
        },
        {
          key: "/auto-purchase-verification",
          label: "Auto Verification",
          icon: <BsCheck2Square style={menuStyle} />,
          to: "/auto-purchase-verification",
          roles: ["admin", "china_admin"],
        },
        {
          key: "/purchase-payment-confirmation",
          label: "Payment Sheet",
          icon: <BiDollarCircle style={menuStyle} />,
          to: "/purchase-payment-confirmation",
          roles: ["admin", "china_admin"],
        },
        {
          key: "/auto-payment",
          label: "Auto Payment",
          icon: <BiEuro style={menuStyle} />,
          to: "/auto-payment",
          roles: ["admin", "china_admin"],
        },
      ],
    },
    {
      key: "tracking",
      label: "Tracking",
      icon: <BarcodeOutlined style={menuStyle} />,
      roles: [
        "admin",
        "bd_purchase",
        "cn_purchase",
        "china_admin",
      ],
      children: [
        {
          key: "/tracking",
          label: "Manual Tracking",
          icon: <BarcodeOutlined style={menuStyle} />,
          to: "/tracking",
          roles: [
            "admin",
            "bd_purchase",
            "cn_purchase",
            "china_admin",
          ],
        },
        {
          key: "/auto-tracking",
          label: "Auto Tracking",
          icon: <KeyOutlined style={menuStyle} />,
          to: "/auto-tracking",
          roles: ["admin", "tracking", "china_admin"],
        },
      ],
    },
    {
      key: "/sorting",
      label: "Sorting",
      icon: <BsListCheck style={menuStyle} />,
      to: "/sorting",
      roles: ["admin", "bd_purchase", "cn_purchase"],
    },
    {
      key: "shipping-charges",
      label: "Shipping Charges",
      icon: <BsCurrencyDollar style={menuStyle} />,
      roles: ["admin", "shipment"],
      children: [
        {
          key: "/shipping-categories",
          label: "Categories",
          icon: <BsListCheck style={menuStyle} />,
          to: "/shipping-categories",
          roles: ["admin", "shipment"],
        },
        {
          key: "/shipping-charges",
          label: "Charges",
          icon: <BsCurrencyDollar style={menuStyle} />,
          to: "/shipping-charges",
          roles: ["admin", "shipment"],
        },
      ],
    },
    {
      key: "/shipping-category",
      label: "Shipping Category",
      icon: <BiGridHorizontal style={menuStyle} />,
      to: "/shipping-category",
      roles: ["super_admin"],
    },
    {
      key: "/qc-customer",
      label: "Customer Qc",
      icon: <ScheduleOutlined style={menuStyle} />,
      to: "/qc-customer",
      roles: ["admin", "shipment", "china_admin"],
    },
    {
      key: "/cash-counter",
      label: "Cash Counter",
      icon: <DollarOutlined style={menuStyle} />,
      to: "/cash-counter",
      roles: ["super_admin", "accountant"],
    },
    {
      key: "/coupons",
      label: "Coupons",
      icon: <GiftOutlined style={menuStyle} />,
      to: "/coupons",
      roles: ["super_admin"],
    },
    {
      key: "/campaigns",
      label: "Campaigns",
      icon: <NotificationOutlined style={menuStyle} />,
      to: "/campaigns",
      roles: ["super_admin"],
    },
    {
      key: "/airport-damaged",
      label: "Airport Damaged",
      icon: <IoAirplane style={menuStyle} />,
      to: "/airport-damaged",
      roles: ["super_admin"],
    },
    {
      key: "/support",
      label: "Support",
      icon: <MessageOutlined style={menuStyle} />,
      to: "/support",
      roles: ["admin", "support", "china_admin"],
    },
    {
      key: "/complains",
      label: "Complains",
      icon: <IoAlertOutline style={menuStyle} />,
      to: "/complains",
      roles: ["admin", "support", "china_admin"],
    },
    {
      key: "/payments",
      label: "Payments",
      icon: <IoCashOutline style={menuStyle} />,
      to: "/payments",
      roles: ["super_admin", "accountant"],
    },
    {
      key: "/point",
      label: "Point",
      icon: <IoStarOutline style={menuStyle} />,
      to: "/point",
      roles: ["super_admin", "accountant"],
    },
    {
      key: "/b2c-recharge",
      label: "B2C Recharge",
      icon: <DollarOutlined style={menuStyle} />,
      to: "/b2c-recharge",
      roles: ["super_admin", "master_admin"],
    },
    {
      key: "refund",
      label: "Refund Hub",
      icon: <LaptopOutlined style={menuStyle} />,
      roles: ["super_admin", "accountant"],
      children: [
        {
          key: "/pending-refunds",
          label: "Pending Refund",
          icon: <Loading3QuartersOutlined style={menuStyle} />,
          to: "/pending-refunds",
          roles: ["super_admin", "accountant"],
        },
        {
          key: "/ready-refunds",
          label: "Ready to Refund",
          icon: <CheckCircleOutlined style={menuStyle} />,
          to: "/ready-refunds",
          roles: ["super_admin", "accountant"],
        },
        {
          key: "/refund-history",
          label: "Refund History",
          icon: <NodeIndexOutlined style={menuStyle} />,
          to: "/refund-history",
          roles: ["super_admin", "accountant"],
        },
      ],
    },
    {
      key: "reports",
      label: "Reports",
      icon: <BarChartOutlined style={menuStyle} />,
      roles: ["super_admin", "accountant"],
      children: [
        {
          key: "/delivery-payment-report",
          label: "Delivery Payment Report",
          icon: <CarOutlined style={menuStyle} />,
          to: "/delivery-payment-report",
          roles: ["super_admin", "accountant"],
        },
        {
          key: "/rmb-transaction-report",
          label: "RMB Transaction Report",
          icon: <MdCurrencyYuan style={menuStyle} />,
          to: "/rmb-transaction-report",
          roles: ["super_admin", "accountant"],
        },
      ],
    },
    {
      key: "/gallery",
      label: "Gallery",
      icon: <IoImageOutline style={menuStyle} />,
      to: "/gallery",
      roles: ["admin", "marketing"],
    },
    {
      key: "/bulk-notification",
      label: "Bulk Notification",
      icon: <NotificationOutlined style={menuStyle} />,
      to: "/bulk-notification",
      roles: ["admin", "marketing"],
    },
    {
      key: "/ideas",
      label: "Ideas",
      icon: <BulbOutlined style={menuStyle} />,
      to: "/ideas",
    },
    // {
    //   key: "/office-complains",
    //   label: "Office Complains",
    //   icon: <ExclamationCircleOutlined style={menuStyle} />,
    //   to: "/office-complains",
    //   roles: ['master_admin'],
    // },
    {
      key: "settings",
      label: "Settings",
      icon: <SettingOutlined style={menuStyle} />,
      roles: ["super_admin"],
      children: [
        {
          key: "/settings/rates",
          label: "Rates & Margin",
          icon: <EuroCircleOutlined style={menuStyle} />,
          to: "/settings/rates",
        },
        {
          key: "/settings/shipping-charges",
          label: "Shipping Charges",
          icon: <CarOutlined style={menuStyle} />,
          to: "/settings/shipping-charges",
        },
      ],
    },
    {
      key: "/admins",
      label: "Admins",
      icon: <UsergroupAddOutlined style={menuStyle} />,
      to: "/admins",
      roles: ["super_admin"],
    },
    {
      key: "/profile",
      label: "Profile",
      icon: <UserOutlined style={menuStyle} />,
      to: "/profile",
    },
    {
      key: "/logout",
      label: "Logout",
      icon: <LogoutOutlined style={{ fontSize: "16px", width: "18px" }} />,
      onClick: () => {
        dispatch(logoutAdmin(() => { }));
        openNotificationWithIcon(
          "success",
          "Success",
          "Logged out successfully",
        );
      },
    },
  ];

  // Helper to filter menu items by role permission
  const filterMenuItems = (items) => {
    return items
      .map((item) => {
        if (item.roles && !isPermitted(roles, item.roles)) {
          return null;
        }
        if (item.children) {
          const filteredChildren = filterMenuItems(item.children);
          return {
            ...item,
            children: filteredChildren,
          };
        }
        return item;
      })
      .filter((item) => {
        if (!item) return false;
        if (item.children && item.children.length === 0) {
          return false;
        }
        return true;
      });
  };

  // Helper to filter permitted menu items by search query
  const filterBySearch = (items, query) => {
    if (!query) return items;
    const lowerQuery = query.toLowerCase();

    return items
      .map((item) => {
        const matchesSelf = item.label.toLowerCase().includes(lowerQuery);
        if (item.children) {
          const filteredChildren = filterBySearch(item.children, query);
          if (matchesSelf || filteredChildren.length > 0) {
            return {
              ...item,
              children: matchesSelf ? item.children : filteredChildren,
            };
          }
          return null;
        }
        return matchesSelf ? item : null;
      })
      .filter(Boolean);
  };

  const permittedItems = React.useMemo(() => {
    return filterMenuItems(rawMenuItems);
  }, [roles]);

  const visibleMenuItems = React.useMemo(() => {
    return filterBySearch(permittedItems, searchQuery);
  }, [permittedItems, searchQuery]);

  // Handle default expansion of active submenu path
  useEffect(() => {
    const activeParentKeys = [];
    const findActiveParent = (items, parentKey) => {
      items.forEach((item) => {
        if (item.to === path) {
          if (parentKey) {
            activeParentKeys.push(parentKey);
          }
        }
        if (item.children) {
          findActiveParent(item.children, item.key);
        }
      });
    };
    findActiveParent(rawMenuItems);
    if (activeParentKeys.length > 0) {
      setUserOpenKeys(activeParentKeys);
      setOpenKeys(activeParentKeys);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  // Handle openKeys toggling when search changes
  useEffect(() => {
    if (searchQuery) {
      const keysToOpen = [];
      const traverse = (items) => {
        items.forEach((item) => {
          if (item.children && item.children.length > 0) {
            keysToOpen.push(item.key);
            traverse(item.children);
          }
        });
      };
      traverse(visibleMenuItems);
      setOpenKeys(keysToOpen);
    } else {
      setOpenKeys(userOpenKeys);
    }
  }, [searchQuery, visibleMenuItems, userOpenKeys]);

  const renderMenuItems = (items) => {
    return items.map((item) => {
      if (item.children) {
        return (
          <SubMenu
            key={item.key}
            icon={item.icon}
            title={item.label}
          >
            {renderMenuItems(item.children)}
          </SubMenu>
        );
      }
      return (
        <Menu.Item
          key={item.key}
          icon={item.icon}
          onClick={item.onClick}
        >
          {item.to ? <Link to={item.to}>{item.label}</Link> : item.label}
        </Menu.Item>
      );
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
      <div style={{ padding: "8px 12px 10px 12px", flexShrink: 0 }}>
        <Input
          ref={searchInputRef}
          prefix={<SearchOutlined style={{ color: "#167389", fontSize: "14px" }} />}
          placeholder="Search menus..."
          allowClear
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            borderRadius: "8px",
            backgroundColor: "#f8fafc",
            padding: "5px 10px",
          }}
          className="sidebar-search-input"
        />
      </div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[path.toString()]}
        openKeys={openKeys}
        onOpenChange={(keys) => {
          if (!searchQuery) {
            setUserOpenKeys(keys);
          }
          setOpenKeys(keys);
        }}
        style={{
          paddingBottom: 64,
          flex: 1,
          overflowY: "auto",
          borderRight: 0,
        }}
      >
        {renderMenuItems(visibleMenuItems)}
      </Menu>
    </div>
  );
}
